import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  twitterCard?: 'summary' | 'summary_large_image';
  noindex?: boolean;
}

export function SEO({
  title = 'Theos - The Most Powerful Bible App',
  description = 'Get instant answers to life\'s most pressing questions directly from the bible. Explore scripture with AI-powered insights and understanding.',
  image = '/og-image.jpg', // You'll need to add this image to your public folder
  url = 'https://theos.ai', // Replace with your actual domain
  type = 'website',
  twitterCard = 'summary_large_image',
  noindex = false,
}: SEOProps) {
  const fullTitle = title.includes('Theos') ? title : `${title} | Theos`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Theos" />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="apple-mobile-web-app-title" content="Theos" />
      <meta name="application-name" content="Theos" />
      <meta name="theme-color" content="#361E06" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
} 